<template>
  <vs-card
    class="cardBorder"
    :style="{
      'background-image': 'url(' + bg_card + ')',
    }"
    ><div class="card-frist">
      <vs-row vs-type="flex" vs-align="flex-end" vs-justify="flex-start">
        <!-- <vs-icon icon="home" size="50px" color="#6FDA79"></vs-icon> -->
        <img
          src="@/assets/images/i-APC/isentenance.png"
          alt=""
          style="cursor: pointer"
        />
        <h1
          id="titleCard"
          class="mt-2 ml-2"
          v-if="nameCompany.edit == false"
        >
          {{ nameCompany.name }}
          <sub style="color: #acacac; font-weight: 500; font-size: 1rem">
            (iSentenance)
          </sub>
        </h1>
        <input
          v-if="nameCompany.edit == true"
          v-model="nameCompany.name"
          v-on:blur="
            nameCompany.edit = false;
            $emit('update');
          "
          @keyup.enter="updateNameCompany(nameCompany)"
        />
      </vs-row>
      <!-- <br /> -->
      <p id="descriptionCard" class="ml-2">
        Unlimited IoT Solution for Next Level of Smart <br />
        Residence
      </p>
      <vs-row
        id="temp"
        vs-type="flex"
        vs-align="center"
        vs-justify="flex-start"
      >
        <img
          src="@/assets/images/i-APC/door_open.png"
          alt=""
          width="50"
          v-if="doorStatus == true"
        />
        <img
          src="@/assets/images/i-APC/door_close.png"
          alt=""
          width="50"
          v-else
        />
        <p class="mt-3 ml-3">
          Door {{ doorStatus == true ? "Open" : "Close" }}
        </p>
      </vs-row>
      <vs-spacer></vs-spacer>
      <div></div>
      <!-- <vs-row
        id="temp"
        vs-type="flex"
        vs-align="center"
        vs-justify="flex-start"
      >
        <vs-icon icon="device_thermostat" size="40px" color="#000"></vs-icon>
        <h2>+25°C</h2>
        <p class="mt-3 ml-3">Outdoor Temperature</p>
      </vs-row>
      <vs-row
        id="climate"
        class="mt-2"
        vs-type="flex"
        vs-align="center"
        vs-justify="flex-start"
      >
        <vs-icon icon="cloud_queue" size="40px" color="#000"></vs-icon>
        <p class="mt-2 ml-3">Fuzzy cloudy weather</p></vs-row
      > -->
    </div>
    <!-- <vs-popup
      class="holamundo"
      title="Edit Name and Image"
      :active.sync="popupActivoa"
      background-color-popup="var(--background-color-sidebar)"
    >
      <vs-upload
        automatic
        action="https://jsonplaceholder.typicode.com/posts/"
        @on-success="successUpload"
      />
    </vs-popup> -->
    <my-upload
      :field="nameFile"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="popupActivo"
      :width="650"
      :height="225"
      img-format="png"
      :langExt="langExt"
      noCircle
      :params="params"
    ></my-upload>
  </vs-card>
</template>

<script>
import "babel-polyfill"; // es6 shim
import myUpload from "vue-image-crop-upload/upload-2.vue";

export default {
  components: { myUpload },
  data() {
    return {
      doorStatus: !true,
      popupActivo: false,
      nameCompany: { name: "Sentenance", edit: false, nameID: 1 },
      bg_card: require("@/assets/images/i-APC/Group_22.png"),
      langExt: {
        hint: "Click or drag the file here to upload",
        loading: "Uploading…",
        noSupported:
          "Browser is not supported, please use IE10+ or other browsers",
        success: "Upload success",
        fail: "Upload failed",
        preview: "Preview",
        btn: {
          off: "Cancel",
          close: "Close",
          back: "Back",
          save: "Upload",
        },
        error: {
          onlyImg: "Image only",
          outOfSize: "Image exceeds size limit: ",
          lowestPx: "Image's size is too low. Expected at least: ",
        },
      },
    };
  },
  mounted() {
    this.getStatusDoor();
    this.getCompanyName();
    // this.time = setInterval(() => {
    //   this.getStatusDoor();
    // }, 20 * 1000);
  },
  beforeDestroy() {
    clearTimeout(this.time);
  },
  methods: {
    editText() {
      console.log(this.$session.get("role"));
      if (this.$session.get("role") == "admin") {
        this.nameCompany.edit = true;
      }
    },
    editImg() {
      if (this.$session.get("role") == "admin") {
        this.popupActivo = true;
      }
    },
    getStatusDoor() {
    //   this.$API.get("iAPC/getdoor/status").then((res) => {
    //     console.log("getdoor", res);
    //     console.log("getdoor", JSON.parse(res.data[0]));
    //     let data = JSON.parse(res.data[0]);
    //     this.doorStatus = data.status == 1 ? true : false;
    //     // if (data.status != "") {
    //     //   this.doorStatus = true
    //     // }
    //     this.time = setTimeout(() => {
    //   this.getStatusDoor();
    // }, 20 * 1000);
      // });
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Lorem ipsum dolor sit amet, consectetur",
      });
    },
    async updateNameCompany(item) {
      try {
        console.log(item);
        item.edit = false;
        let body = {
          nameID: 1,
          newName: item.name,
        };
        let res = await this.$API.post("name/changename", body);
        if (res.status == 200) {
          this.$vs.notify({
            title: "Success",
            text: "Name Change Successful",
            color: "primary",
            position: "top-center",
          });
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Failed to Change Name",
          color: "danger",
          position: "top-center",
        });
        await this.getCompanyName();
      }
    },
    async getCompanyName() {
      let res = await this.$API.get("name/getname/1");
      if (res.status == 200) {
        console.log("getCompanyName", res);
        this.nameCompany.name = res.data[0].name;
      }
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field) {
      console.log("-------- crop success --------");
      //   console.log(imgDataUrl, field);
      this.imgDataUrl = imgDataUrl;

      //   const token = this.$session.get("accessToken");
      //   const herder = { Authorization: "Bearer " + token };
      //   this.headers = herder;
      //   console.log(this.headers);

      // call func convart image to file
      var file = this.dataURLtoFile(this.imgDataUrl, this.nameFile);
      this.uploadbymac(file);
    },
    uploadbymac(file) {
      // set fotmat data before send to database
      const formData = new FormData();
      formData.append("file", file);
      formData.append("mac", this.mac);
      console.log(formData);

      // call API uplaod image
      try {
        this.$API
          .post("upload/tag", formData)
          .then((res) => {
            console.log(res);
            this.$API.get("indoortag/" + this.mac).then((res) => {
              // console.log(res.data[0]);

              this.$session.set("image", res.data[0].image);
            });
            this.$vs.notify({
              color: "success",
              title: "Upload Success",
              text: "Upload image complete!",
              position: "top-center",
            });
            this.show = !this.show;
            setTimeout(() => {
              location.reload();
            }, 1000);
          })
          .catch((err) => {
            this.$vs.notify({
              color: "danger",
              title: "Upload Fail",
              text: "There is something wrong with the upload system",
              position: "top-center",
            });
          });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-frist {
  height: 100%;
  input {
    border: 2px solid #6fda79;
    border-radius: 10px;
    font-size: 1.5rem;
    width: 50%;
    &:focus {
      border: 2px solid #6fda79;
    }
  }
}
.cardBorder {
  border-radius: 20px;
  background-image: url("../../../../../../assets/images/i-APC/Group_22.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right center;
  //   max-height: min-content;

  #titleCard {
    color: #6fda79;
  }
  #descriptionCard {
    font-size: 1rem;
    color: #acacac;
    margin-top: 0.5rem;
  }
  #temp {
    h2 {
      color: #000;
    }
    p {
      font-size: 1rem;
      font-weight: 600;
      // color: #fff;
      color: #838383;
    }
  }
  #climate {
    p {
      font-size: 1rem;

      color: #000;
    }
  }
}
@media only screen and (max-width: 1025px) {
  .cardBorder {
    background-position: center center;
  }
}
@media only screen and (max-width: 600px) {
  .cardBorder {
    background-position: left center;
  }
}
</style>